import React from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';

const WorkDashboard = () => {
  const { t } = useTranslation();

  // 샘플 프로젝트 데이터
  const projects = [
    {
      id: 1,
      name: 'Project Alpha',
      status: 'in_progress',
      progress: 65,
      dueDate: '2026-02-15',
      team: ['김철수', '이영희', '박민수'],
      tasks: { total: 24, completed: 16 }
    },
    {
      id: 2,
      name: 'Project Beta',
      status: 'planning',
      progress: 15,
      dueDate: '2026-03-01',
      team: ['김철수', '박민수'],
      tasks: { total: 12, completed: 2 }
    },
    {
      id: 3,
      name: 'Project Gamma',
      status: 'review',
      progress: 90,
      dueDate: '2026-01-20',
      team: ['이영희'],
      tasks: { total: 18, completed: 16 }
    }
  ];

  const statusLabels = {
    planning: '기획 중',
    in_progress: '진행 중',
    review: '검토 중',
    completed: '완료'
  };

  const statusColors = {
    planning: '#9CA3AF',
    in_progress: '#3B82F6',
    review: '#F59E0B',
    completed: '#10B981'
  };

  // 통계 계산
  const stats = {
    total: projects.length,
    inProgress: projects.filter(p => p.status === 'in_progress').length,
    review: projects.filter(p => p.status === 'review').length,
    completed: projects.filter(p => p.status === 'completed').length
  };

  return (
    <div className="max-w-[1200px] mx-auto py-8 px-6 max-md:py-6 max-md:px-4">
      <div className="mb-8">
        <h1 className="text-[28px] font-bold text-[#1e293b] m-0 mb-2">{t('nav.workDashboard')}</h1>
        <p className="text-[15px] text-[#64748b] m-0">{t('nav.workDashboardDesc')}</p>
      </div>

      {/* 통계 카드 */}
      <div className="grid grid-cols-4 gap-5 mb-10 max-lg:grid-cols-2 max-md:gap-3">
        <div className="bg-white rounded-xl p-6 flex items-center gap-4 shadow-[0_1px_3px_rgba(0,0,0,0.08)] border border-[#e2e8f0] max-md:p-4">
          <div className="text-[32px] w-14 h-14 flex items-center justify-center bg-[#f8fafc] rounded-xl max-md:text-2xl max-md:w-11 max-md:h-11">📁</div>
          <div className="flex flex-col">
            <span className="text-[28px] font-bold text-[#1e293b] max-md:text-[22px]">{stats.total}</span>
            <span className="text-sm text-[#64748b]">전체 프로젝트</span>
          </div>
        </div>
        <div className="bg-white rounded-xl p-6 flex items-center gap-4 shadow-[0_1px_3px_rgba(0,0,0,0.08)] border border-[#e2e8f0] max-md:p-4">
          <div className="text-[32px] w-14 h-14 flex items-center justify-center bg-[#f8fafc] rounded-xl max-md:text-2xl max-md:w-11 max-md:h-11">🔄</div>
          <div className="flex flex-col">
            <span className="text-[28px] font-bold text-[#1e293b] max-md:text-[22px]">{stats.inProgress}</span>
            <span className="text-sm text-[#64748b]">진행 중</span>
          </div>
        </div>
        <div className="bg-white rounded-xl p-6 flex items-center gap-4 shadow-[0_1px_3px_rgba(0,0,0,0.08)] border border-[#e2e8f0] max-md:p-4">
          <div className="text-[32px] w-14 h-14 flex items-center justify-center bg-[#f8fafc] rounded-xl max-md:text-2xl max-md:w-11 max-md:h-11">👀</div>
          <div className="flex flex-col">
            <span className="text-[28px] font-bold text-[#1e293b] max-md:text-[22px]">{stats.review}</span>
            <span className="text-sm text-[#64748b]">검토 중</span>
          </div>
        </div>
        <div className="bg-white rounded-xl p-6 flex items-center gap-4 shadow-[0_1px_3px_rgba(0,0,0,0.08)] border border-[#e2e8f0] max-md:p-4">
          <div className="text-[32px] w-14 h-14 flex items-center justify-center bg-[#f8fafc] rounded-xl max-md:text-2xl max-md:w-11 max-md:h-11">✅</div>
          <div className="flex flex-col">
            <span className="text-[28px] font-bold text-[#1e293b] max-md:text-[22px]">{stats.completed}</span>
            <span className="text-sm text-[#64748b]">완료</span>
          </div>
        </div>
      </div>

      {/* 프로젝트 목록 */}
      <div className="mb-10">
        <div className="flex justify-between items-center mb-5">
          <h2 className="text-xl font-semibold text-[#1e293b] m-0">최근 프로젝트</h2>
          <Link to="/projects" className="text-sm text-[#3b82f6] no-underline font-medium hover:underline">전체 보기 →</Link>
        </div>

        <div className="grid grid-cols-3 gap-5 max-lg:grid-cols-2 max-md:grid-cols-1">
          {projects.map(project => (
            <div
              key={project.id}
              className="bg-white rounded-xl p-6 shadow-[0_1px_3px_rgba(0,0,0,0.08)] border border-[#e2e8f0] transition-all duration-200 cursor-pointer hover:-translate-y-0.5 hover:shadow-[0_4px_12px_rgba(0,0,0,0.1)]"
            >
              <div className="flex justify-between items-start mb-4">
                <h3 className="text-lg font-semibold text-[#1e293b] m-0">{project.name}</h3>
                <span
                  className="text-xs font-medium text-white py-1 px-2.5 rounded-[20px]"
                  style={{ backgroundColor: statusColors[project.status] }}
                >
                  {statusLabels[project.status]}
                </span>
              </div>

              <div className="mb-4">
                <div className="flex justify-between text-[13px] text-[#64748b] mb-2">
                  <span>진행률</span>
                  <span>{project.progress}%</span>
                </div>
                <div className="h-2 bg-[#e2e8f0] rounded overflow-hidden">
                  <div
                    className="h-full rounded transition-[width] duration-300"
                    style={{
                      width: `${project.progress}%`,
                      backgroundColor: statusColors[project.status]
                    }}
                  />
                </div>
              </div>

              <div className="flex gap-5 mb-4 text-[13px] text-[#64748b]">
                <div className="flex items-center gap-1.5">
                  <span className="text-sm">📋</span>
                  <span>{project.tasks.completed}/{project.tasks.total} 작업</span>
                </div>
                <div className="flex items-center gap-1.5">
                  <span className="text-sm">📅</span>
                  <span>{project.dueDate}</span>
                </div>
              </div>

              <div className="flex">
                {project.team.map((member, idx) => (
                  <span
                    key={idx}
                    className="w-8 h-8 rounded-full bg-gradient-to-br from-[#3B82F6] to-[#8B5CF6] text-white text-[13px] font-semibold flex items-center justify-center border-2 border-white -ml-2 first:ml-0"
                  >
                    {member.charAt(0)}
                  </span>
                ))}
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* 최근 활동 */}
      <div className="bg-white rounded-xl p-6 shadow-[0_1px_3px_rgba(0,0,0,0.08)] border border-[#e2e8f0]">
        <h2 className="text-xl font-semibold text-[#1e293b] m-0 mb-5">최근 활동</h2>
        <div className="flex flex-col gap-4">
          <div className="flex gap-4 pb-4 border-b border-[#f1f5f9] last:border-b-0 last:pb-0">
            <span className="text-xl w-10 h-10 flex items-center justify-center bg-[#f8fafc] rounded-[10px] flex-shrink-0">📝</span>
            <div>
              <p className="text-sm text-[#334155] m-0 mb-1 leading-normal"><strong className="text-[#1e293b]">김철수</strong>님이 <strong className="text-[#1e293b]">Project Alpha</strong>에 새 작업을 추가했습니다.</p>
              <span className="text-xs text-[#94a3b8]">10분 전</span>
            </div>
          </div>
          <div className="flex gap-4 pb-4 border-b border-[#f1f5f9] last:border-b-0 last:pb-0">
            <span className="text-xl w-10 h-10 flex items-center justify-center bg-[#f8fafc] rounded-[10px] flex-shrink-0">✅</span>
            <div>
              <p className="text-sm text-[#334155] m-0 mb-1 leading-normal"><strong className="text-[#1e293b]">이영희</strong>님이 <strong className="text-[#1e293b]">Project Gamma</strong>의 작업을 완료했습니다.</p>
              <span className="text-xs text-[#94a3b8]">1시간 전</span>
            </div>
          </div>
          <div className="flex gap-4 pb-4 border-b border-[#f1f5f9] last:border-b-0 last:pb-0">
            <span className="text-xl w-10 h-10 flex items-center justify-center bg-[#f8fafc] rounded-[10px] flex-shrink-0">💬</span>
            <div>
              <p className="text-sm text-[#334155] m-0 mb-1 leading-normal"><strong className="text-[#1e293b]">박민수</strong>님이 <strong className="text-[#1e293b]">Project Beta</strong>에 코멘트를 남겼습니다.</p>
              <span className="text-xs text-[#94a3b8]">3시간 전</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default WorkDashboard;
